import {PageProps} from '@/types';
import styles from './Organisation.module.scss'
import Page from "@/Pages/Page";
import {Organisation as OrganisationType} from "@/types/Organisation";
import Photos from "@/Organisms/Photos/Photos";
import Chip from "@/Atoms/Chip";
import {Service} from "@/types/Service";
import Place from "@/Atoms/Icons/Place";
import IconPhone from "@/Atoms/Icons/IconPhone";
import Envelope from "@/Atoms/Icons/Envelope";
import IconLink from "@/Atoms/Icons/IconLink";

export default function Organisation({ organisation, service}: PageProps<{
  organisation: OrganisationType,
  service?: Service,
}>) {

  const hasContact = organisation.address
    || organisation.phone
    || organisation.email
    || organisation.website

  return <Page title={organisation.name} harvestId={`organisation-${organisation.id}`}>

    <section>

      <div className={`container`}>

        <h1 className={'ml-10 my-5 !text-left'}>Adressengids</h1>

        <div className={'flex items-start flex-col md:flex-row gap-5'}>

          <div className={'grow md:columns bg-white rounded-lg p-10'}>
            <div className={styles.header}>
              <h2 className={'mb-5'}>{organisation.name}</h2>
              {organisation.logo && <img src={organisation.logo.url} alt={organisation.name}/>}

            </div>

            <p className={'flex gap-2 flex-wrap'}>{organisation.services?.map((s, index) =>
              <a key={index} href={`/adressen-gids/categorie-${s.slug}`}>
                <Chip highlighted={!!(service && service.id === s.id)}>{s.title}</Chip>
              </a>
            )}</p>

            <hr/>

            {organisation.description?.length > 10 && <>
              <h3 className={'mt-5'}>Over ons</h3>
              {organisation.description}
            </>}

            {organisation.services && organisation.services.length > 0 && <>
              <h3 className={'mt-5'}>Diensten</h3>
              <p>
                {organisation.services.map(service => service.title).join(', ')}
              </p>
            </>}


            {organisation.photos.length > 0 && <>
              <h3 className={'mt-5'}>Foto's</h3>
              <Photos images={organisation.photos} />
            </>}
          </div>
          {hasContact && <div className={'grow md:grow-0 md:w-80 bg-white rounded-lg p-10'}>
            <h3 className={'mb-5'}>Contactgegevens</h3>
            <div className={styles.contactdetails}>
              {organisation.address?.address && <div>
                <div><Place/></div>
                <div><a
                  href={`https://www.google.com/maps/dir//${organisation.address.address}, ${organisation.address.place?.title}`}>{organisation.address.address}, {organisation.address.postalcode} {organisation.address.place?.title}</a>
                </div>
              </div>}

              {organisation.phone && <div>
                <div><IconPhone/></div>
                <div><a href={`tel:${organisation.phone}`}>{organisation.phone}</a></div>
              </div>}

              {organisation.email && <div>
                <div><Envelope/></div>
                <div><a href={`mailto:${organisation.email}`}>{organisation.email}</a></div>
              </div>}

              {organisation.website && <div>
                <div><IconLink/></div>
                <div><a href={organisation.website}>{organisation.website}</a></div>
              </div>}

            </div>
          </div>}

        </div>


      </div>
    </section>
  </Page>
}
